import { render, staticRenderFns } from "./AssetRemove.vue?vue&type=template&id=45c5e19b&"
import script from "./AssetRemove.vue?vue&type=script&lang=js&"
export * from "./AssetRemove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports